import classes from './rightStyles.module.css'
const Right = () => {
    return (
        <div
            className={classes.right}
        >
        </div >
    )
}
export default Right;